/**
*   Sistema Emurb DC - Prefeitura de Aracaju, EMURB
*   Desenvolvido com amor por:
*   @author Sálvio Aragão Almeida Júnior
*   e
*   @author Leonardo Araújo
*   para automação do cálculo de taxas e geração de documentos da Coordenadoria de Urbanismo (COURB)
**/

import React from "react"

import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"

import "index.css"

import App from "App.js"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
    <BrowserRouter>
        <App/>
    </BrowserRouter>
)
